import { memo } from 'react';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogHeader from '@zenbusiness/zui/DialogHeader';
import Divider from '@zenbusiness/zui/Divider';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import { ContentWrapStyle } from '#client/components/ScanToDownloadAppModal/styles';
import useModalDisplayTracker from '#client/hooks/useModalDisplayTracker';

const ContentWrapStyled = styled(Box)(ContentWrapStyle);

const ScanToDownloadAppModal = ({ handleClose }) => {
  useModalDisplayTracker({
    elementName: 'App_QR_banking_check_deposit',
    elementText: 'App_QR_banking_check_deposit',
    appPageName: 'banking_account_notfunded_dashboard'
  });

  return (
    <Dialog
      onClose={handleClose}
      open
    >
      <Box sx={{ padding: '8px' }}>
        <DialogHeader
          subtitle="Easily deposit checks on your schedule, right from your phone."
          sx={{
            textAlign: 'center'
          }}
          title="Scan the code to download our app"
        />
        <DialogContent>
          <ContentWrapStyled>
            <SharedAsset
              alt=""
              src="/icon/misc/download_qr_code.png"
              width={200}
            />
          </ContentWrapStyled>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Button
              onClick={handleClose}
              size="lg"
              variant="outlined"
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

ScanToDownloadAppModal.propTypes = {
  handleClose: PropTypes.func
};

export default memo(ScanToDownloadAppModal);
